import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import LandingPage from "./pages/LandingPage";
import BookAppointment from "./pages/BookAppointment";
import Dashboard from "./pages/Dashboard";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const theme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#000000", // Black background
      paper: "#121212", // Slightly lighter for paper components if used
    },
    primary: {
      main: "#F7E98E", // Blue
    },
    secondary: {
      main: "#FFD700", // Yellow (Gold)
    },
    text: {
      primary: "#ffffff", // White text
      secondary: "#FFD700", // Optional: yellow text for contrast
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />{" "}
      {/* Normalize CSS.  CssBaseline: Applies a global reset of CSS styles to standardize 
      the appearance of HTML elements across browsers.*/}
      <BrowserRouter>
        {/* This component is part of the react-router-dom library and is used to
        enable client-side routing in a React application. 
        Enables client-side routing, making it possible to switch between different 
        components based on the current URL.*/}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <Navbar />
          <main style={{ flex: 1 }}>
            {/*This creates a <main> HTML element with a style that uses flex: 1, which means 
            this element will take up all available space in its parent container when using 
            Flexbox layout. It allows other elements inside the same flex container to adjust 
            their size based on the available space. 
            This code uses react-router-dom to render different components 
            (LandingPage, BookAppointment, and Dashboard) based on the current URL path. 
            The main element wraps the routes and is styled to take up the remaining space 
            in its parent container.*/}
            <Routes>
              {/*This component is part of react-router-dom and is used to define a set of 
              routes in the application. It will render the route that matches the current URL.*/}
              <Route path="/" element={<LandingPage />} />
              <Route path="/book-appointment" element={<BookAppointment />} />
              <Route path="/dashboard" element={<Dashboard />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
